import { Stack, Dialog, Button, Typography, DialogContent, DialogActions } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';

import { DayOffType } from 'src/type/day-off-config';
import dayjs from 'dayjs';
import InfoGrid from 'src/components/ui-kit/info-grid';
import { sleep } from 'src/utils/sleep';
import { LoadingButton } from '@mui/lab';
import { useBoolean } from 'src/hooks/use-boolean';

type ApproveDialogProps = {
  open: boolean;
  onClose: VoidFunction;
  data: DayOffType | undefined;
  handleReload: VoidFunction;
  clearSelectedData: VoidFunction;
};

export default function ConfirmRemoveDialog({
  open,
  onClose,
  data,
  handleReload,
  clearSelectedData,
}: ApproveDialogProps) {
  const isSubmitting = useBoolean(false);
  const getInfo = () => {
    if (!data) return [];

    const { date, startTime, endTime } = data;

    return [
      { label: 'วันที่', value: dayjs(date).format('DD MMMM BBBB') },
      { label: 'เวลาเริ่ม', value: dayjs(startTime, 'HH:mm:ss').format('HH:mm น.') },
      { label: 'เวลาสิ้นสุด', value: dayjs(endTime, 'HH:mm:ss').format('HH:mm น.') },
    ];
  };

  const onSubmit = async () => {
    try {
      isSubmitting.onTrue();
      if (!data || !data.id) return;
      await axios.delete(endpoints.dayOffs.delete(data.id));

      handleReload();
      beforeClose();

      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    } finally {
      isSubmitting.onFalse();
    }
  };

  const beforeClose = async () => {
    onClose();
    await sleep(200);
    clearSelectedData();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={beforeClose}>
      <Stack direction="row" alignItems="center" sx={{ p: 3 }}>
        <Typography variant="h6">ยืนยันการลบ</Typography>
      </Stack>

      <DialogContent>
        <InfoGrid infos={getInfo()} />
        <Typography variant="body2" sx={{ mb: 2 }}>
          คุณต้องการลบข้อมูลนี้ใช่หรือไม่?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={beforeClose}>
          ยกเลิก
        </Button>
        {/* <Button variant="contained" onClick={onSubmit}>
          ดำเนินการต่อ
        </Button> */}
        <LoadingButton variant="contained" loading={isSubmitting.value} onClick={onSubmit}>
          ดำเนินการต่อ
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
